
<template>
  <div class="cardList">
    <div style="height: 36px;text-align: right;margin:5px 0 20px 0;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="formInline.keyword" placeholder="请输入名称查询" suffix-icon="el-icon-search"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="disFlex cardListS" v-if="tableData.rows.length>0">
      <div class="cardBlockN" v-for="(item,i) in tableData.rows">
        <div class="cardBlockN-top" :style="'background-color:'+colors[i]">
          <div class="cardTitle">{{item.cradname}}</div>
          <div class="cardTime">获取时间：{{item.createTime}}</div>
        </div>
        <div class="cardBlockN-bot disFlex">
          <div class="flex1" @click="showXz(item)" >
            <img src="@/assets/images/icons/xiazai.png"/>下载
          </div>
          |
          <div class="flex1" @click="showCardInfo(item)">
            <img src="@/assets/images/icons/view.png" />查看
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height: 200px;background-color: #fff;text-align: center;">
      <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
      <div style="font-size: 18px;color: #999999;">暂无数据</div>
    </div>

    <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
      :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
    </el-pagination>

    <el-dialog title="证书详情" :visible.sync="dialogVisible" width="800px">
      <div id="firefoxA" style="display:none;"></div>
      <div id="page1" style="padding: 20px;">
        <table class="zscardTable">
          <tr>
            <td>姓名</td>
            <td colspan="2">{{activeRow.username}}</td>
            <td>身份证号</td>
            <td style="width: 200px;">{{activeRow.card}}</td>
          </tr>
          <tr>
            <td>获取时间</td>
            <td colspan="4">{{activeRow.createTime}}</td>
          </tr>
          <tr>
            <td colspan="5">安全教育和培训内容</td>
          </tr>
          <tr>
            <td>培训内容</td>
            <td>指标名称</td>
            <td>完成情况</td>
            <td>培训指标</td>
            <td>培训结果</td>
          </tr>
          <tr>
            <td>视频学习</td>
            <td>完成率</td>
            <td>{{activeRow.score}}</td>
            <td>80%</td>
            <td>合格</td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isXz">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xzBtn">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import html2canvas from 'html2canvas';
  export default {
    name: 'StadyList',
    props: ['creator', 'wjSrc'],
    data() {
      return {
        formInline: {
          keyword: '',
          rows: 10,
          page: 1,
          userid: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        activeRow:{

        },
        colors: [
          '#00C0D5',
          '#FF6666',
          '#1C95F3',
          '#99CC33',
          '#999933',
          '#FFCC33',
          '#FF9966',
          '#666699',
          '#009999',
          '#FF99CC'
        ],
        dialogVisible: false,
        isXz: false
      }
    },
    methods: {
      getList: function(id) {
         if(this.formInline.userid){
           this.$axios.get('/kt/ktCardUser/getlistPage.htm?' + this.$qs.stringify(this.formInline)).then(res => {
             var data = res.data;
             this.tableData = data;
           })
         }
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      showCardInfo: function(item) {
        this.activeRow=item;
        this.isXz = false;
        this.dialogVisible = true
      },
      showXz: function(item) {
         this.activeRow=item;
        this.dialogVisible = true;
        this.isXz = true;
      },
      xzBtn: function() {
        html2canvas(document.getElementById('page1')).then(function(canvas) {
          // document.body.appendChild(canvas);
          canvas.id = "mycanvas";
          canvas.toBlob(
            //传入blob对象
            function(blob) {
              //创建一个img标签
              var newImg = document.createElement("img"),
                //以blob对象为基础创建一个url
                url = URL.createObjectURL(blob)

              newImg.onload = function() {
                //加载后销毁
                // URL.revokeObjectURL(url);
                var aEle = document.createElement("a");
                aEle.href = url;

                aEle.download = "img.png";
                document.getElementById('firefoxA').appendChild(aEle);
                aEle.click();
              };

              //img标签属性赋值
              newImg.src = url;
              //添加为子元素
              document.body.appendChild(newImg);
            });
        });
      }
    },
    created: function() {
      this.$set(this.formInline, 'userid', this.creator);
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList();
        },
        deep: true //true 深度监听
      },
      creator: {
        handler(val, oldVal) {
          this.$set(this.formInline, 'userid', val);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .stadyBlok {
    height: 118px;
    opacity: 1;
    margin-right: 20px;
    background: #00bc68;
    border-radius: 4px;
  }

  .cardListS {
    flex-wrap: wrap;
    border-top: 1px solid #F2F2F2;
    padding-top: 20px;
  }

  .cardBlockN {
    height: 200px;
    width: 266px;
    border-radius: 2px;
    margin-right: 20px;
    text-align: center;
  }

  .cardBlockN-top {
    width: 266px;
    height: 160px;
    opacity: 1;
    background-color: #00c0d5;
    background-image: url(../../assets/images/yuanhuan.png);
    border-radius: 2px 2px 0px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
  }

  .cardTitle {
    opacity: 1;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .cardTime {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  .cardBlockN-bot {
    height: 40px;
    opacity: 1;
    background: #f7f9fa;
    border: 1px solid #e9e9e9;
    line-height: 40px;
    border-top: none;
    font-size: 14px;
    color: #9a9a9a;
    cursor: pointer;
  }

  .cardBlockN-bot img {
    margin-right: 4px;
  }

  .zscardTable {
    line-height: 45px;
    font-size: 14px;
  }

  .zscardTable td {
    text-align: center;
    width: 180px;
    border: 1px solid #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/CardList.vue